/** @format */

import React, { Component } from 'react';
import {
  Menu,
  Button,
  Input,
  Icon,
  Form,
  Dropdown,
  Checkbox,
} from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import './RequestsToolbar.css';

@inject('RequestsStore', 'UserStore')
@observer
class RequestsToolbar extends Component {
  renderNewRequestButton = () => {
    const { UserStore } = this.props;
    if (UserStore.user.role !== 'warehouse') {
      return (
        <Menu.Item>
          <Button
            size="tiny"
            onClick={() => this.props.history.push('/requests/new/')}
            color="green"
          >
            <Icon name="plus" />
            <span className="button-text">&nbsp;Nuova Richiesta</span>
          </Button>
        </Menu.Item>
      );
    }
  };

  render() {
    const { RequestsStore } = this.props;
    const deepSearch = RequestsStore.requestsParams.deepSearch.active;
    const isResearchActive = RequestsStore.isResearchActive;
    const activeFilter = RequestsStore.requestsParams.filter.status;
    return (
      <Menu className="request-toolbar" borderless size="tiny">
        <Menu.Menu position="left">
          <Menu.Item
            onClick={() => RequestsStore.filterRequests('attiva')}
            active={activeFilter === 'attiva'}
          >
            Attive
          </Menu.Item>
          <Menu.Item
            onClick={() => RequestsStore.filterRequests('archiviata')}
            active={activeFilter === 'archiviata'}
          >
            Archiviate
          </Menu.Item>
          <Menu.Item>
            <Dropdown
              text="Filtri"
              icon="filter"
              labeled
              button
              floating
              className={`filter-dropdown ${
                RequestsStore.areClientSideFiltersActive
                  ? 'filter-dropdown__filters-enabled'
                  : ''
              }`}
            >
              <Dropdown.Menu className="filter-dropdown-menu">
                <Dropdown
                  className="filter-dropdown-entry"
                  selection
                  placeholder="Disponibilità"
                  clearable
                  onChange={(_, data) => {
                    RequestsStore.setClientSideFilter({
                      byAvailability: data.value || null,
                    });
                  }}
                  value={
                    RequestsStore.requestsParams.clientSideFilters
                      .byAvailability
                  }
                  options={[
                    {
                      key: 'available',
                      value: 'available',
                      text: 'Disponibile',
                    },
                    {
                      key: 'unavailable',
                      value: 'unavailable',
                      text: 'Non Disponibile',
                    },
                  ]}
                />
                <Dropdown
                  selection
                  placeholder="Venditore"
                  clearable
                  onChange={(_, data) => {
                    RequestsStore.setClientSideFilter({
                      bySeller: data.value || null,
                    });
                  }}
                  options={RequestsStore.sellerList}
                  className="filter-dropdown-entry"
                  value={
                    RequestsStore.requestsParams.clientSideFilters.bySeller
                  }
                />
                <Dropdown
                  selection
                  placeholder="Località"
                  clearable
                  onChange={(_, data) => {
                    RequestsStore.setClientSideFilter({
                      byLocation: data.value || null,
                    });
                  }}
                  options={RequestsStore.locationList}
                  className="filter-dropdown-entry"
                  value={
                    RequestsStore.requestsParams.clientSideFilters.byLocation
                  }
                />
                <Dropdown
                  selection
                  placeholder="Comunicazione"
                  clearable
                  onChange={(_, data) => {
                    RequestsStore.setClientSideFilter({
                      byCommunication: data.value !== '' ? data.value : null,
                    });
                  }}
                  options={[
                    {
                      key: 'with',
                      value: 'with',
                      text: 'Con comunicazione',
                    },
                    {
                      key: 'without',
                      value: 'without',
                      text: 'Senza comunicazione',
                    },
                  ]}
                  className="filter-dropdown-entry"
                  value={
                    RequestsStore.requestsParams.clientSideFilters
                      .byCommunication
                  }
                />
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
          {RequestsStore.areClientSideFiltersActive && (
            <Menu.Item>
              <Button
                size="tiny"
                onClick={RequestsStore.clearClientSideFilters}
              >
                <Icon name="close" />
                <span className="button-text">&nbsp;Rimuovi Filtri</span>
              </Button>
            </Menu.Item>
          )}
        </Menu.Menu>
        <Menu.Menu position="right">
          <Menu.Item>
            <Form size="tiny" onSubmit={() => RequestsStore.openDeepSearch()}>
              <Input
                size="small"
                value={RequestsStore.requestsParams.searchValue}
                className={
                  isResearchActive ? 'search-input open' : 'search-input'
                }
                onChange={(e, input) =>
                  RequestsStore.searchRequest(input.value)
                }
                icon="search"
                placeholder="Digita per ricerca veloce o premi invio per ricerca avanzata"
              ></Input>
            </Form>
          </Menu.Item>
          <Menu.Item
            className="clickable"
            onClick={() => {
              if (deepSearch) {
                RequestsStore.closeDeepSearch();
              } else {
                RequestsStore.openDeepSearch();
              }
            }}
          >
            <small className={deepSearch ? 'strong' : null}>
              ricerca avanzata
            </small>
          </Menu.Item>
          {this.renderNewRequestButton()}
        </Menu.Menu>
      </Menu>
    );
  }
}

export default withRouter(RequestsToolbar);
